import { render, staticRenderFns } from "./ShipmentsList.vue?vue&type=template&id=4bc0fc30"
import script from "./ShipmentsList.vue?vue&type=script&lang=js"
export * from "./ShipmentsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports